import { generatePath, PathParam } from 'react-router-dom';

/** Convert POJO to FormData - DOES NOT WORK WITH NESTED OBJECTS */
export const objToFormData = (obj: Record<string, any>): FormData => {
  return Object.keys(obj).reduce((formData, key) => {
    const value = obj[key];
    if (Array.isArray(value)) {
      value.forEach((v) => formData.append(key, v));
    } else {
      formData.append(key, value);
    }
    return formData;
  }, new FormData());
};

/**
 * Like react-router's `generatePath`, but supports absolute URLs.
 * `generatePath` collapses repeated slashes, which would turn `https://` into `https:/`.
 */
export const generateApiUrl = <Path extends string>(
  url: Path,
  params?: Record<PathParam<Path>, string | null>
): string => {
  const origin = url.match(/^https?:\/\/[^/]+/)?.[0] ?? '';
  return origin + generatePath(url.slice(origin.length), params);
};
